import React, { useState, useEffect } from "react";
import "../css/Video.css";
import VideoList from "./VideoList";
import apiUrl from "../utility/apiUrl";
import useMediaQuery from "../utility/useMediaQuery";

const YoutubeEmbed = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const handleVideoClick = (youtubeId) => {
    window.open(`https://www.youtube.com/watch?v=${youtubeId}`, "_blank");
  };

  // const videos = [
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },

  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  //   {
  //     id: "26053",
  //     imageSrc: "https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg",
  //     title: "INI CET 2024 July session: Student Reactions",
  //     // views: "18.7K",
  //     // date: "May 19, 2024",
  //     // likes: "76",
  //     youtubeId: "EEH4kqiYMTc",
  //   },
  // ];
  const [videoData, setVideoData] = useState([]);

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        const response = await fetch(apiUrl + "/api/v1/video/list", {
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": "any",
          },
          method: "POST",
        });
        const data = await response.json();
        setTimeout(() => {
          setVideoData(data);
        }, 1000);
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideoData();
  }, []);

  return (
    <div className="video-container-main">
      <h3>Learn more about Colleges and Exams in these short Videos</h3>
      {isMobile ? (
        <div className="video-equal-stack">
          {videoData.slice(0, 4).map((video, index) => (
            <div key={video?.id || video?.youtubeId || index} className="video-equal-item">
              <div className="video-equal-responsive">
                <iframe
                  src={`https://www.youtube.com/embed/${video.youtubeId}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                  title={video?.title || `Video ${index + 1}`}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="video-container">
          <div className="video-responsive">
            {videoData.length > 0 && (
              <iframe
                width="853"
                height="480"
                src={`https://www.youtube.com/embed/${videoData[0].youtubeId}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
              />
            )}
          </div>
          <div className="video-list-container">
            <VideoList videos={videoData.slice(1, 4)} onItemClick={handleVideoClick} />
          </div>
        </div>
      )}
    </div>
  );
};

export default YoutubeEmbed;
